import type { BaseTranslation } from '../i18n-types';

export const roomSettings = {
    goToMain: 'Main page',
    allowCameraAccessTitle: 'Allow access to your camera and microphone to start chat',
    enableCameraTitle: 'Enable Camera and Microphone to Start Video Chat',
    enableCameraSubtitle:
      'You can’t start a video chat because you have denied access to the camera and microphone or your camera is unavailable now. You can allow access in your browser settings. Also, we recommend to close all other apps that can use your camera.',
    searchButton: 'Find a match',
    callButton: 'Start a call',
    currentCallButton: 'Start the call',
    cancelCall: 'Cancel the call',
    mirrorMyVideo: 'Mirror my video',
} satisfies BaseTranslation;
